import { Tooltip } from 'antd'
import AddIcon from 'components/ui/general/icons/AddIcon'
import React from 'react'
import './CustomMetaFileUploadIcon.scss'

const CustomMetaFileUploadIcon = ({
  onClick = () => null,
  toolTipTitle = ''
}) => {
  return (
    <div
      className='custom-meta-file-upload-icon'
      onClick={onClick}
    >
      <div className='file-icon-wrapper'>
        <Tooltip placement='right' title={toolTipTitle} >
          <AddIcon />
        </Tooltip>
      </div>
    </div>
  )
}

export default CustomMetaFileUploadIcon
